import { usePendingCompany } from '../../../../../hooks/fetchers/usePendingCompany/usePendingCompany';
import ProfileLayout from '../../../../commons/ProfileLayout/ProfileLayout';
import ProfileHeader from '../ProfileHeader/ProfileHeader';
import ProfileCompanyForm from './ProfileCompanyForm/ProfileCompanyForm';
import Loading from '../../../../commons/Loading/Loading';

export default () => {
  const { data: pendingCompany, isLoading } = usePendingCompany();

  return (
    <ProfileLayout>
      <ProfileHeader />
      {isLoading ? (
        <Loading />
      ) : (
        <section className="profile__main-row">
          <ProfileCompanyForm disabled={Boolean(pendingCompany)} {...{ pendingCompany }} />
        </section>
      )}
    </ProfileLayout>
  );
};
